import Group from 'components/utils/Group'
import Label from 'LuxKit/Label'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { FormattedMessage } from 'react-intl'
import Sheet from 'components/utils/Sheet'

function TripLandingPageLookingForAi() {
  return (
    <Sheet padding="40 20">
      <Group direction="vertical" gap={20} horizontalAlign="center">
        <Group direction="vertical" gap={8} horizontalAlign="center">
          <Label kind="primary" variant="highlight">
            <FormattedMessage
              id="A-gSmbgoL4cZE0RZwN5M"
              defaultMessage="Beta"
              description="Label indicating the AI chat feature is in beta on trip planner landing page"
            />
          </Label>
          <Heading variant="heading3">
            <FormattedMessage
              id="PPlLsRS208Lkk1dsLSWp"
              defaultMessage="Looking for your <i>AI chats?</i>"
              description="Heading prompting users about AI chat availability on trip planner landing page"
              values={{
                i: (chunks) => <i>{chunks}</i>,
              }}
            />
          </Heading>
          <BodyText variant="medium" align="center">
            <FormattedMessage
              id="zZ_192Ipp_VRk1iRCwQf"
              defaultMessage="AI chat isn’t available on mobile yet. Switch to desktop for the full AI experience."
              description="Message informing users that AI chat is only available on desktop on trip planner landing page"
            />
          </BodyText>
        </Group>
      </Group>
    </Sheet>
  )
}

export default TripLandingPageLookingForAi
